exports = module.exports = require("../../../../../vuesora/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#questionInput.text-white{color:#fff}.send-button-col{-webkit-box-flex:0;-ms-flex:0 0 50px;flex:0 0 50px}@media screen and (min-width:40em){.send-button-col{-webkit-box-flex:0;-ms-flex:0 0 175px;flex:0 0 175px}}.avatar-col{-webkit-box-flex:0;-ms-flex:0 0 50px;flex:0 0 50px}.loading-element{position:absolute;top:0;left:0;width:100%;height:100%;background-color:hsla(0,0%,100%,.8);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:32px;z-index:10}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../vuesora/node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-75446f46","scoped":false,"hasInlineConfig":true}!../vuesora/node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vuesora/src/components/EmailForm.vue
// module id = h3WU
// module chunks = 0